export default class {
  constructor() {
    this.$menuOpen = $(".hamburger");
    this.$body = $("body");
    this.activeClass = "is-active";
    this.bodyClass = "menu-open";
  }

  init() {
    this.setListeners();
  }

  setListeners() {
    const vm = this;
    this.$menuOpen.on({
      click() {
        const $this = $(this);
        if (!$this.hasClass(vm.activeClass)) {
          $this.addClass(vm.activeClass);
          vm.$body.addClass(vm.bodyClass);
          vm.$body.removeClass("search-open");
          $(".js-search-form").removeClass("open");
        } else {
          $this.removeClass("is-active");
          vm.$body.removeClass(vm.bodyClass);
        }
      },
    });

    function fixViewportHeight() {
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight / 100}px`,
      );
    }

    window.addEventListener("DOMContentLoaded", fixViewportHeight);
    window.addEventListener("orientationchange", fixViewportHeight);
    window.addEventListener("resize", fixViewportHeight);
    window.addEventListener("load", fixViewportHeight);
  }
}
